import { render, staticRenderFns } from "./GrayBoxItem.vue?vue&type=template&id=577e26ba&"
import script from "./GrayBoxItem.vue?vue&type=script&lang=js&"
export * from "./GrayBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports